import { composer } from '../../../../../component-decorators/composer';
import React, { useEffect } from 'react';
import s from '../solution-rate-reviews.scss';
import { ModalNames } from '../../../../modals/modals';
import { SolutionPageCtx } from '../../..';
import { Heading, Box, Text, TextButton } from 'wix-style-react';
import { BlockReviewsHelper } from './block-reviews-helper';
import { biLogger } from '../../../../../bi';
export var NoReviews = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    // tslint:disable-next-line:react-hooks-nesting
    var _a = React.useState(false), isHelperOpen = _a[0], setOpenHelper = _a[1];
    var textNoReviews = 'solution.page.noReviewsYet';
    var openModal = function (app) {
        if (props.isEligibleForReviews === false) {
            if (!isHelperOpen) {
                biLogger.appMarketReviewAppNotInstalledAlert({
                    app_id: app === null || app === void 0 ? void 0 : app.baseInfo.id,
                });
            }
            setOpenHelper(!isHelperOpen);
        }
        else {
            props.marketplaceStore.openModal(ModalNames.RATE_APP, {
                app: app,
                closeModal: function () { return props.marketplaceStore.closeAllModals(); },
            });
        }
    };
    // tslint:disable-next-line:react-hooks-nesting
    useEffect(function () {
        if (isHelperOpen) {
            setOpenHelper(false);
        }
    }, [props.appId]);
    return (React.createElement("div", { "data-testid": "no-reviews" },
        React.createElement(Box, { direction: "vertical" },
            React.createElement("div", { className: s.noReviewsTitle },
                React.createElement(Heading, { appearance: 'H2' }, props.t('solution.page.noReviewsYetTitle'))),
            React.createElement(Text, null,
                props.t(textNoReviews),
                React.createElement(SolutionPageCtx.Consumer, null, function (value) { return (React.createElement(TextButton, { onClick: function () { return openModal(value.app); }, dataHook: 'add-review' },
                    React.createElement(BlockReviewsHelper, { app: value === null || value === void 0 ? void 0 : value.app, opened: isHelperOpen, target: 'solution.page.reviews.empty.addReview' }))); })))));
});
//# sourceMappingURL=solution-no-reviews.js.map